import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import Loader from '../components/Loader.js'
import { useSelector, useDispatch } from 'react-redux'
import 'swiper/css/pagination'
// import { Pagination } from "swiper";
import { getAllCategories } from '../actions/categoryAction'
import { clearErrors, getProduct } from '../actions/productAction'
// Import Swiper styles
// import "swiper/css";
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
// import required modules
import {
  EffectFade,
  Autoplay,
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
} from 'swiper'

const About = () => {
  const dispatch = useDispatch()
  const { categories } = useSelector((state) => state.categories)
  const { loading, error, products } = useSelector((state) => state.products)

  useEffect(() => {
    dispatch(getProduct())
    dispatch(getAllCategories())
  }, [dispatch, error, alert])

  return (
    <>
      {/* {loading ? (
        <Loader />
      ) : (
        <> */}
      {/*<!-- Page Banner Section Start -->*/}
      <div
        className='section page-banner-section'
        style={{ backgroundImage: 'url(../assets/images/banner.jpg)' }}
      >
        <div className='overlayBanner'></div>
        <div className='container'>
          {/*<!-- Page Banner Content End -->*/}
          <div className='page-banner-content'>
            <h2 className='title'>About Us</h2>

            <ul className='breadcrumb'>
              <li>
                <Link to='/'>Home</Link>
              </li>
              <li className='active'>About Us</li>
            </ul>
          </div>
          {/*<!-- Page Banner Content End -->*/}
        </div>
      </div>
      {/*<!-- Page Banner Section End -->*/}

      {/*<!-- History Section Start -->*/}
      <div className='section section-padding-02'>
        <div className='container'>
          {/*<!-- History content End -->*/}
          <div className='history-content text-center'>
            <div className='section-title-03'>
              {/*<h6 className="sub-title">Our History</h6>*/}
              <h2 className='title' style={{ textTransform: 'unset' }}>
                KBM Training & Recruitment
              </h2>
            </div>

            <p><span><strong>KBM Training and Recruitment</strong> is a leading training provider specialising in Accounting, Finance, Taxation, Audit and Business Administration. We provide hands-on training under the supervision of chartered accountants in real business environment in collaboration with KBM Chartered Certified Accountants &amp; Registered Auditors, a recognised partner of the <strong>ACCA</strong> (global body for professional accountants) and an<strong>&nbsp;ACCA Approved Employer at Gold Level</strong>.</span></p>
            <p ><span>We offer<strong>&nbsp;flexible delivery &amp; timetables</strong> to suit your needs delivering one-to-one hand-on training. We are committed to provide specialist knowledge and professionalism; our training programmes include extensive use of modern accounting software like<strong>&nbsp;Sage, QuickBooks, SAP, SAPA, SAGE Compliance, Excel, Xero and Sage One.</strong></span></p>
            <p ><span>We are accredited by<strong>&nbsp;AAT, NCFE and OCR (Oxford Cambridge &amp; RSA)</strong>. We also provide non accredited training programmes from fundamental to professional skills level and have helped thousands of candidates in Training, Employment and Further Education.</span></p>
            <p ><span >We also deliver public funding projects including European Social Fund (ESF), Education &amp; Skills Funding Agency (ESFA), Department for Education (DfE), Local Government and EU Erasmus+. The programmes include Traineeships, Apprenticeships, NEET, Adult Education Budget, Advanced Learning Loans, Erasmus+ (KA1 &amp; KA2) and Employability programmes for Local Authorities. In addition, we provide pre-employment training &amp; support, work placements, vocational skills &amp; retraining, advice on an interview, CV writing, job search, etc.</span></p>
            <p ><span>We are on the<strong>&nbsp;ESFA RoATP</strong> (Register of Apprenticeship Training Providers) with an Outstanding Grade &ndash; <strong>UKPRN # 10045412</strong></span></p>
            <p><span>We are<strong>&nbsp;Matrix Certified</strong> for Information, Advice and Guidance (IAG) to help individuals progress into employment &amp; develop career potential to gain the skills and qualifications they need to get jobs and further education.</span></p>
            <p><span>Working closely with employers, we ensure that our training programmes match their business priorities. Setting clear objectives ensures our learners have a positive attitude to learning and enjoy their programmes while making good progress.</span></p>
          </div>
          {/*<!-- History content End -->*/}

          {/*<!-- History Icon End -->*/}
          {/*<div className='history-icon text-center'>
            <img src='../assets/images/icon/icon-5.jpg' alt='Icon' />
          </div>*/}
          {/*<!-- History Icon End -->*/}
        </div>
      </div>
      {/* <!-- History Section End -->*/}

      {/* <!-- Images Gallery Section Start -->*/}
      {/*<div className='section section-padding'>*/}
      {/*  <div className='container'>*/}
      {/*    <div className='row'>*/}
      {/*      <div className='col-lg-8'>*/}
      {/*        /!*<!-- Image Gallery Start -->*!/*/}
      {/*        <div className='image-gallery'>*/}
      {/*          <img*/}
      {/*            src='../assets/images/images-gallery/image-1.jpg'*/}
      {/*            width='770'*/}
      {/*            height='290'*/}
      {/*            alt='gallery'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*        /!*<!-- Image Gallery End -->*!/*/}
      {/*      </div>*/}
      {/*      <div className='col-lg-4'>*/}
      {/*        /!*<!-- Image Gallery Start -->*!/*/}
      {/*        <div className='image-gallery'>*/}
      {/*          <img*/}
      {/*            src='../assets/images/images-gallery/image-2.jpg'*/}
      {/*            width='370'*/}
      {/*            height='290'*/}
      {/*            alt='gallery'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*        /!*<!-- Image Gallery End -->*!/*/}
      {/*      </div>*/}
      {/*      <div className='col-lg-6'>*/}
      {/*        /!*<!-- Image Gallery Start -->*!/*/}
      {/*        <div className='image-gallery'>*/}
      {/*          <img*/}
      {/*            src='../assets/images/images-gallery/image-3.jpg'*/}
      {/*            height='570'*/}
      {/*            height='290'*/}
      {/*            alt='gallery'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*        /!*<!-- Image Gallery End -->*!/*/}
      {/*      </div>*/}
      {/*      <div className='col-lg-6'>*/}
      {/*        /!*<!-- Image Gallery Start -->*!/*/}
      {/*        <div className='image-gallery'>*/}
      {/*          <img*/}
      {/*            src='../assets/images/images-gallery/image-4.jpg'*/}
      {/*            width='570'*/}
      {/*            height='290'*/}
      {/*            alt='gallery'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*        /!*<!-- Image Gallery End -->*!/*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<!-- Images Gallery Section End -->*/}

      {/*<div className='section bg-color-01 mt-5'>*/}
      {/*  <div className='products-banner products-banner-active'>*/}
      {/*    <div className='swiper-container'>*/}
      {/*      <Swiper*/}
      {/*        slidesPerView={2}*/}
      {/*        spaceBetween={0}*/}
      {/*        navigation={false}*/}
      {/*        loop={true}*/}
      {/*        breakpoints={{*/}
      {/*          640: {*/}
      {/*            slidesPerView: 2,*/}
      {/*            spaceBetween: 0,*/}
      {/*          },*/}
      {/*          768: {*/}
      {/*            slidesPerView: 3,*/}
      {/*            spaceBetween: 0,*/}
      {/*          },*/}
      {/*          1024: {*/}
      {/*            slidesPerView: 4,*/}
      {/*            spaceBetween: 0,*/}
      {/*          },*/}
      {/*        }}*/}
      {/*        modules={[Navigation]}*/}
      {/*        className='mySwiper'*/}
      {/*      >*/}
      {/*        /!*{categories && categories.slice(0,4).map((item) => (*/}
      {/*                          <li key={item._id} className={splitLocation[1] === `shop/category/${item.name}` ? "active" : ``}>*/}
      {/*                              <Link to={`/shop/category/${item.name}`}>{item.name}</Link>*/}
      {/*                          </li>*/}
      {/*                      ))}*!/*/}
      {/*        {categories &&*/}
      {/*          categories.map((item) => (*/}
      {/*            <SwiperSlide key={item._id}>*/}
      {/*              <div className='swiper-slide'>*/}
      {/*                /!*<!-- Single Products Banner Start -->*!/*/}
      {/*                <div className='single-products-banner'>*/}
      {/*                  <img*/}
      {/*                    src={item.images[0]?.url}*/}
      {/*                    width='480'*/}
      {/*                    height='600'*/}
      {/*                    alt='Category'*/}
      {/*                  />*/}

      {/*                  <div className='products-banner-content'>*/}
      {/*                    <div className='banner-content-wrapper'>*/}
      {/*                      <h4 className='title'>*/}
      {/*                        <Link*/}
      {/*                          className='text-capitalize'*/}
      {/*                          to={`/shop/category/${item.name}`}*/}
      {/*                        >*/}
      {/*                          {item.name}*/}
      {/*                        </Link>*/}
      {/*                      </h4>*/}
      {/*                      <span className='products-count'>*/}
      {/*                        {*/}
      {/*                          products.filter(*/}
      {/*                            (product) => product.category === item.name*/}
      {/*                          ).length*/}
      {/*                        }{' '}*/}
      {/*                        Products*/}
      {/*                      </span>*/}
      {/*                      <Link*/}
      {/*                        to={`/shop/category/${item.name}`}*/}
      {/*                        className='arrow'*/}
      {/*                      >*/}
      {/*                        <i className='pe-7s-angle-right'></i>*/}
      {/*                      </Link>*/}
      {/*                    </div>*/}
      {/*                  </div>*/}
      {/*                </div>*/}
      {/*                /!*<!-- Single Products Banner End -->*!/*/}
      {/*              </div>*/}
      {/*            </SwiperSlide>*/}
      {/*          ))}*/}
      {/*      </Swiper>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/* </>
      )} */}
    </>
  )
}

export default About
